module.exports = __webpack_public_path__ + "img/2.4d291eb6.jpg";